if (!customElements.get("product-cards")) {
  class ProductCards extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.productCards = this.querySelectorAll(".product-card");
      this.initCards();
      this.onColorUpdate();
    }

    initCards() {
      this.productCards.forEach((card) => {
        // const checkedInput = card.querySelector('[name^="color-"]:checked');
        const checkedInput = null;
        if (checkedInput) {
          const selectedColor = checkedInput.value;
          this.updateProductInfo(card, selectedColor);
        }
      });
    }

    onColorUpdate() {
      this.productCards.forEach((card) => {
        const inputs = card.querySelectorAll('[name^="color-"]');
        inputs.forEach((input) => {
          input.addEventListener("change", () => {
            const selectedColor = input.value;
            this.updateProductInfo(card, selectedColor);
          });
        });
      });
    }

    updateProductInfo(card, selectedColor) {
      const productData = JSON.parse(
        card.querySelector(".product-json").innerHTML
      );
      const activeVariant = productData.variants.find((variant) =>
        variant.options.includes(selectedColor)
      );
      const cardImage = card.querySelector(".product-card__picture img");
      const currentPrice = card.querySelector(".product-card__current-price");
      const originalPrice = card.querySelector(".product-card__original-price");
      const productLinks = card.querySelectorAll(".product-card__link");

      if (activeVariant) {
        cardImage.src = activeVariant.featured_image;
        cardImage.alt = activeVariant.featured_image_alt;

        currentPrice.textContent = activeVariant.price;
        productLinks.forEach((link) => (link.href = activeVariant.url));

        if (originalPrice) {
          originalPrice.textContent = activeVariant.compare_at_price;
        }
      }
    }
  }

  customElements.define("product-cards", ProductCards);
}
